"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetUpdatePayDataFeedbackATPlus = exports.useGetUpdatePayDataFeedback = void 0;
const react_i18next_1 = require("react-i18next");
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const ToastIcon_1 = require("../../../../../components/Shared/ToastIcon");
const useGetFrontendValidationFeedback_1 = require("./useGetFrontendValidationFeedback");
const useGetUpdatePayDataFeedback = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const frontendValidationFeedback = (0, useGetFrontendValidationFeedback_1.useGetFrontendValidationFeedback)(props);
    if (!!frontendValidationFeedback) {
        return frontendValidationFeedback;
    }
    let status = ToastIcon_1.ToastIconStatus.loading;
    let message = t(`time_and_attendance_HourlyBreakdown_SelfClassification_FeedbackModal_UpdatePayData_Processing`);
    const { data, isLoading } = props.useUpdatePayDataResponse.updatePayDataState;
    const defaultErrorMessage = t(`time_and_attendance_HourlyBreakdown_SelfClassification_FeedbackModal_UpdatePayData_DefaultError`);
    if (!isLoading) {
        if ((0, isEmpty_1.default)(data)) {
            status = ToastIcon_1.ToastIconStatus.error;
            message = defaultErrorMessage;
        }
        else {
            if ((0, isEmpty_1.default)(data.errorMessage)) {
                status = ToastIcon_1.ToastIconStatus.success;
                message = t(`time_and_attendance_HourlyBreakdown_SelfClassification_FeedbackModal_UpdatePayData_Success`);
            }
            else {
                status = ToastIcon_1.ToastIconStatus.error;
                message = t(`time_and_attendance_HourlyBreakdown_SelfClassification_FeedbackModal_UpdatePayData_ErrorCode${data.statusCode}`, defaultErrorMessage);
            }
        }
    }
    return { status, message };
};
exports.useGetUpdatePayDataFeedback = useGetUpdatePayDataFeedback;
const useGetUpdatePayDataFeedbackATPlus = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const frontendValidationFeedback = (0, useGetFrontendValidationFeedback_1.useGetFrontendValidationFeedbackATPlus)(props);
    if (!!frontendValidationFeedback) {
        return frontendValidationFeedback;
    }
    let status = ToastIcon_1.ToastIconStatus.loading;
    let message = t(`time_and_attendance_HourlyBreakdown_SelfClassification_FeedbackModal_UpdatePayData_Processing`);
    const defaultErrorMessage = t(`time_and_attendance_HourlyBreakdown_SelfClassification_FeedbackModal_UpdatePayData_DefaultError`);
    if (props.isUpdateSelfClassification) {
        const { data, loading, error } = props.useEditPayCodeResponse.editPayCodeState;
        if (!loading) {
            const failedOperations = data === null || data === void 0 ? void 0 : data.payCodeOperationStatus.filter((payCodeOperation) => {
                if (payCodeOperation.status !== 'Success')
                    return payCodeOperation;
            });
            if ((failedOperations === null || failedOperations === void 0 ? void 0 : failedOperations.length) == 0 && (0, isEmpty_1.default)(error)) {
                status = ToastIcon_1.ToastIconStatus.success;
                message = t(`time_and_attendance_HourlyBreakdown_SelfClassification_FeedbackModal_UpdatePayData_Success`);
            }
            else {
                status = ToastIcon_1.ToastIconStatus.error;
                message = t(defaultErrorMessage);
            }
        }
    }
    else {
        const { data, loading, error } = props.useAddPayCodeResponse.addPayCodeState;
        if (!loading) {
            if ((data === null || data === void 0 ? void 0 : data.status) == 202 && (0, isEmpty_1.default)(error)) {
                status = ToastIcon_1.ToastIconStatus.success;
                message = t(`time_and_attendance_HourlyBreakdown_SelfClassification_FeedbackModal_UpdatePayData_Success`);
            }
            else {
                status = ToastIcon_1.ToastIconStatus.error;
                message = t(defaultErrorMessage);
            }
        }
    }
    return { status, message };
};
exports.useGetUpdatePayDataFeedbackATPlus = useGetUpdatePayDataFeedbackATPlus;
